<template>
    <cadastro-simples-list
        endpoint="lingua-indigena"
        rota-base="/admin/lingua-indigena"
        titulo="LÍNGUAS INDÍGENAS"
        titulo-singular="Língua Indígena"
        :colunas-extras='[{"campo":"codigo_inep","label":"Código INEP","tipo":"string","maxLength":10}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
